module.exports = __webpack_public_path__ + "img/star.dd3900a4.svg";